import * as actionTypes from "../reducers/actionTypes";

export const setFavoriteFixtures = (data: any) => {
  return { type: actionTypes.SET_FAVORITE_FIXTURE, payload: data };
};

export const addFavoriteMatch = (match: { id: number | string; [key: string]: any }) => {
  return { type: actionTypes.ADD_FAVORITE_MATCH, payload: match };
};

export const removeFavoriteMatch = (matchId: number | string) => {
  return { type: actionTypes.REMOVE_FAVORITE_MATCH, payload: { id: matchId } };
};
